<template>
  <div>
    <Introduction></Introduction>
    <div id="main">
      <Welcome></Welcome>
      <Abroad></Abroad>
      <Research></Research>
      <Work></Work>
    </div>
  </div>
</template>

<script>
import Introduction from "@/components/Introduction.vue";
import Welcome from "@/components/Welcome.vue";
import Abroad from "@/components/Abroad.vue";
import Research from "@/components/Research.vue";
import Work from "@/components/Work.vue";

export default {
  name: "App",
  data() {
    return {
      introduction: {
        highlight: 'I am <a href="index.html">Toby</a>',
        message:
          ",<br />working in Sydney 🦘,<br />originally from Karlsruhe 👶."
      }
    };
  },
  components: {
    Introduction,
    Welcome,
    Abroad,
    Research,
    Work
  }
};
</script>
